/* Matcha Sunday — purchase selector logic. NO radio inputs (click/keyboard
   driven), external file, prices in data-prices attr. Nothing for speed apps to
   mangle. */
(function(){
  function getForm(root){
    var info = root.closest('.product-info') || document;
    return info.querySelector('form[action*="/cart/add"]')
        || document.querySelector('product-form form[action*="/cart/add"]')
        || document.querySelector('form[id^="product-form"]');
  }
  function planInput(form){
    if(!form) return null;
    var i = form.querySelector('input[name="selling_plan"][data-ms]');
    if(!i){ i=document.createElement('input'); i.type='hidden'; i.name='selling_plan'; i.setAttribute('data-ms',''); form.appendChild(i); }
    return i;
  }
  function fmt(c){ return '$' + (c/100).toFixed(2); }
  function boot(root){
    if(!root || root.__ms) return; root.__ms = true;
    var MAP={}; try{ MAP=JSON.parse(root.getAttribute('data-prices')||'{}'); }catch(e){}
    var freqWrap = root.querySelector('[data-freq]');
    function variantId(){ var f=getForm(root); var idi=f&&f.querySelector('[name="id"]'); return idi?idi.value:Object.keys(MAP)[0]; }
    function mode(){ return root.getAttribute('data-mode') || 'subscribe'; }
    function freqEl(){ return root.querySelector('.ms-sub__chip.is-selected') || root.querySelector('.ms-sub__chip'); }
    function freqId(){ var c=freqEl(); return c?c.getAttribute('data-plan'):''; }
    function freqText(){ var c=freqEl(); return c?c.textContent.trim():''; }
    function set(sel,val){ root.querySelectorAll(sel).forEach(function(e){ e.textContent=val; }); }
    function update(){
      var d=MAP[variantId()]||MAP[Object.keys(MAP)[0]]; if(!d) return;
      var pid=freqId(); var plan=d.plans[pid]||d.plans[Object.keys(d.plans)[0]]||{p:d.once,d:30};
      var compare=d.compare||d.once;
      set('[data-once-price]', fmt(d.once));
      set('[data-sub-price]', fmt(plan.p));
      root.querySelectorAll('[data-compare]').forEach(function(e){ e.textContent=fmt(compare); });
      var save=compare>plan.p?Math.round((compare-plan.p)/compare*100):0;
      set('[data-banner-save]', save+'% off');
      if(plan.d){ set('[data-sub-perday]', fmt(Math.round(plan.p/plan.d))+'/day'); }
      set('[data-freq-label]', 'ships every '+freqText());
      if(freqWrap) freqWrap.hidden = mode()!=='subscribe';
      var inp=planInput(getForm(root)); if(inp){ inp.value = mode()==='subscribe'?pid:''; try{ inp.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){} }
    }
    function selectMode(m){
      root.setAttribute('data-mode', m);
      root.querySelectorAll('.ms-sub__opt').forEach(function(o){
        var on = o.getAttribute('data-mode')===m;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-pressed', on?'true':'false');
      });
      update();
    }
    root.querySelectorAll('.ms-sub__opt').forEach(function(opt){
      opt.addEventListener('click', function(){ selectMode(opt.getAttribute('data-mode')); });
      opt.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); selectMode(opt.getAttribute('data-mode')); } });
    });
    root.querySelectorAll('.ms-sub__chip').forEach(function(chip){
      chip.addEventListener('click', function(e){
        e.stopPropagation();
        root.querySelectorAll('.ms-sub__chip').forEach(function(c){ c.classList.toggle('is-selected', c===chip); });
        selectMode('subscribe');
      });
    });
    document.addEventListener('variant:change', function(){ setTimeout(update,60); });
    var f=getForm(root); if(f){ f.querySelectorAll('[name="id"]').forEach(function(i){ i.addEventListener('change', function(){ setTimeout(update,60); }); }); }
    update();
  }
  function init(){ document.querySelectorAll('subscription-selector.ms-sub').forEach(boot); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
